import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import {
    buscarOrganizadoresConfiguracion,
    crearUbicacionConfiguracion
} from '../../../actions/configuracion';

const NuevaUbicacion = ({ ubicacion, reestablecerUbicacion, idOrganizadorVista }) => {

    const dispatch = useDispatch();

    const { listado: listadoOrganizadores, areaActual } =
        useSelector(state => state.configuracion.organizadores);

    const [show, setShow] = useState(false);
    const [idOrganizador, setIdOrganizador] = useState('');
    const [nombre, setNombre] = useState('');

    // Si por alguna razón no hubiera organizadores cargados, podrías
    // disparar buscarOrganizadoresConfiguracion(areaActual) aquí,
    // pero normalmente vienes desde la vista de organizadores y ya están.

    useEffect(() => {
        if (ubicacion) {
            setShow(true);
            setNombre('');
            setIdOrganizador(idOrganizadorVista); // default: organizador actual
        } else {
            setShow(false);
        }
    }, [ubicacion, idOrganizadorVista]);

    const handleClose = () => {
        setShow(false);
        setNombre('');
        setIdOrganizador('');
        reestablecerUbicacion(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!nombre.trim() || !idOrganizador) return;

        const resp = await dispatch(
            crearUbicacionConfiguracion({
                id_organizador: idOrganizador,
                nombre: nombre.trim(),
                idOrganizadorVista
            })
        );

        if (resp && resp.success) {
            handleClose();
        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <form onSubmit={handleSubmit}>
                <div className="modal-header">
                    <h5 className="modal-title">Agregar ubicación</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleClose}
                        aria-label="Close"
                    ></button>
                </div>

                <div className="modal-body">
                    <div className="mb-3">
                        <label className="form-label">Organizador</label>
                        <select
                            className="form-select"
                            value={idOrganizador}
                            onChange={e => setIdOrganizador(e.target.value)}
                        >
                            <option value="">Seleccione un organizador</option>
                            {listadoOrganizadores && listadoOrganizadores.map(o => (
                                <option key={o._id} value={o._id}>
                                    {o.nombre}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Nombre</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nombre de la ubicación"
                            value={nombre}
                            onChange={e => setNombre(e.target.value)}
                        />
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleClose}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default NuevaUbicacion;
